module.exports = __webpack_public_path__ + "static/img/Reed-Mahoney.29d9732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reed-Mahoney.jpg
// module id = cjC+
// module chunks = 0